"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CoachChatModel {
    constructor(cache) {
        this.key = (userId, withMemberId) => `${CoachChatModel.CHAT_DB}.${userId}.${withMemberId}`;
        this.getMessages = async (userId, withMemberId) => (await this.cache
            .getArray(this.key(userId, withMemberId))
            .withDefault([])
            .asPromise());
        this.setMessages = async (userId, withMemberId, messages) => this.cache.setArray(this.key(userId, withMemberId), messages).asPromise();
        this.cache = cache;
    }
}
CoachChatModel.CHAT_DB = "Mock.ChatModel.COACH_CHAT_DB";
exports.default = CoachChatModel;
//# sourceMappingURL=CoachChatModel.js.map